var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-input el-input--mini"},[_c('masked-input',{staticClass:"el-input__inner",attrs:{"type":"text","value":_vm.val!=='0'?_vm.val:'',"mask":_vm.ms,"guide":false,"placeholderChar":"#","disabled":_vm.disabled},on:{"change":_vm.change,"input":function($event){_vm.val=$event},"blur":_vm.blur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }